__turbopack_context__.v({
  "bannerContainer": "OutletCardBanner-module-scss-module__GJfFsq__bannerContainer",
  "bannerImage": "OutletCardBanner-module-scss-module__GJfFsq__bannerImage",
  "bannerOverlay": "OutletCardBanner-module-scss-module__GJfFsq__bannerOverlay",
  "logoContainer": "OutletCardBanner-module-scss-module__GJfFsq__logoContainer",
  "logoImage": "OutletCardBanner-module-scss-module__GJfFsq__logoImage",
  "outletClosed": "OutletCardBanner-module-scss-module__GJfFsq__outletClosed",
});
